import sessionService from "@/api/sessionService/sessionService"
import localstorage from "@/store/localstorage"
import axios, { AxiosRequestConfig } from "axios"

const ApiService = {
  async postAsync(proxyPath: any, uri: any, data: any, auths?: any) {
    return this.request({ method: "post", url: uri, data, auth: auths, baseURL: proxyPath })
  },
  async getAsync(proxyPath: any, uri: any) {
    return this.request({ method: "get", url: uri, baseURL: proxyPath })
  },
  async deleteAsync(proxyPath: any, uri: any, data: any) {
    return this.request({ method: "delete", url: uri, baseURL: proxyPath, data })
  },
  async putAsync(proxyPath: any, uri: any, data: any, auths?: any) {
    return this.request({ method: "put", url: uri, data, auth: auths, baseURL: proxyPath })
  },

  // Makes sure there's a valid session token first, and if the server still rejects it (401),
  // gets a new one and retries once
  async request(config: AxiosRequestConfig) {
    await sessionService.ensureSession()
    const tokenUsed = localstorage.getToken()
    try {
      const response = await axios.request({ ...config, headers: this.getHeaders() })
      return response.data
    } catch (error) {
      if (!axios.isAxiosError(error) || error.response?.status !== 401) throw error
      // Another request may already have refreshed it
      if (localstorage.getToken() === tokenUsed) await sessionService.ensureSession(true)
      const response = await axios.request({ ...config, headers: this.getHeaders() })
      return response.data
    }
  },

  getHeaders() {
    return {
      AGID: localstorage.getToken(),
      OS: "Web",
      "Content-Type": "application/json",
      Accept: "application/json",
    }
  },
}

export default ApiService
